export enum ShowcaseAdditionalQuestionType {
  Input = 1,
  Textarea,
  Radio,
  Checkbox,
  Select,
  MultiSelect,
}

export enum ShowcaseAdditionalQuestionVisibility {
  All = 1,
  Jury,
  None,
}

export interface ShowcaseAdditionalQuestionOption {
  id: number
  label: string
  order: number
}

export interface ShowcaseAdditionalQuestion {
  id: number
  question: string | Record<string, string>
  type: ShowcaseAdditionalQuestionType
  placeholder: string | Record<string, string> | null
  description: string | Record<string, string> | null
  is_required: boolean
  visibility: ShowcaseAdditionalQuestionVisibility
  order: number
  options: ShowcaseAdditionalQuestionOption[]
}
